import React from "react";
import MemberSubscriptionSummary from "./MemberSubscriptionSummary";
import QuickActions from "./QuickActions";
import { ImageBackground } from "react-native";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import AccountCredits from "./AccountCredits";
import { svgURL } from "utils/fileUtils";
import { AccountMemberDetails } from "features/types";

const CustomerWallet = ({ member }: { member: AccountMemberDetails }) => {
  const { data: branding } = useFetchTenantBrandingQuery();

  if (!branding) return null;

  const { name } = branding;
  const tenantLogo = svgURL(name);

  return (
    <ImageBackground
      source={{ uri: tenantLogo }}
      imageStyle={{
        opacity: 0.2,
      }}
    >
      {/* Member reservation details */}
      <MemberSubscriptionSummary member={member} />
      <AccountCredits />
      <QuickActions />
    </ImageBackground>
  );
};

export default CustomerWallet;
